import * as React from "react";
import { Component } from "react";
import { Button, Col, ControlLabel, FormControl, FormGroup, Glyphicon } from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IBaseState } from "src/interfaces";
import { IServiceChargeRowProps } from "./interfaces";

export default class ServiceChargeSmallRow extends Component<IServiceChargeRowProps, IBaseState> {
  public constructor(props: IServiceChargeRowProps) {
    super(props);

    this.state = { loading: true };

    this.deleteServiceCharge = this.deleteServiceCharge.bind(this);

    this.handleDescriptionChanged = this.handleDescriptionChanged.bind(this);
    this.handleValueChanged = this.handleValueChanged.bind(this);
    this.handleUnitChanged = this.handleUnitChanged.bind(this);
    this.handleRateChanged = this.handleRateChanged.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return <LoadingStatus singular={true} width={10} height={10} />;
    }

    const { serviceCharge } = this.props;

    return (
      <tr key={serviceCharge.id}>
        <td id="input_cell">
          <Button bsSize="small" bsStyle="danger" onClick={this.deleteServiceCharge}>
            <Glyphicon glyph="glyphicon glyphicon-remove" />
          </Button>
          <FormGroup bsSize="small" controlId="description">
            <Col xs={5} sm={5} md={5} componentClass={ControlLabel}>
              Description
            </Col>
            <Col xs={7} sm={7} md={7}>
              <FormControl
                bsSize="small"
                type="text"
                value={serviceCharge.description}
                onChange={this.handleDescriptionChanged}
              />
            </Col>
          </FormGroup>
          <FormGroup bsSize="small" controlId="value">
            <Col xs={5} componentClass={ControlLabel}>
              Value
            </Col>
            <Col xs={7} sm={7} md={7}>
              <CurrencyInput
                className="servicecharge-input form-control input-sm"
                id="servicecharge_value"
                inputType="text"
                value={serviceCharge.value}
                precision={2}
                allowNegative={true}
                selectAllOnFocus={true}
                onChangeEvent={this.handleValueChanged}
              />
              <select id="unit" value={serviceCharge.unit} onChange={this.handleUnitChanged}>
                <option value="kWh">kWh</option>
                <option value="K-P">O-P</option>
                <option value="K-OP">On-P</option>
                <option value="Days">Days</option>
                <option value="Cost">Cost</option>>
                <option value="" />
              </select>
            </Col>
          </FormGroup>
          <FormGroup bsSize="small" controlId="rate">
            <Col xs={5} componentClass={ControlLabel}>
              Rate
            </Col>
            <Col xs={7} sm={7} md={7}>
              <CurrencyInput
                className="servicecharge-input form-control input-sm"
                id="serviceCharge_rate"
                inputType="text"
                value={serviceCharge.rate}
                onChangeEvent={this.handleRateChanged}
                precision={6}
                allowNegative={true}
                selectAllOnFocus={true}
              />
            </Col>
          </FormGroup>
          <FormGroup bsSize="small" controlId="totalCharge">
            <Col xs={5} componentClass={ControlLabel}>
              Total Charge
            </Col>
            <Col xs={7} sm={7} md={7}>
              <CurrencyInput
                className="servicecharge-input form-control input-sm"
                id="servicecharge_totalCharge"
                inputType="text"
                value={serviceCharge.totalCharge}
                prefix={"$"}
                precision={2}
                allowNegative={true}
                tabIndex={-1}
                selectAllOnFocus={false}
              />
            </Col>
          </FormGroup>
        </td>
      </tr>
    );
  }

  private handleDescriptionChanged(e: any) {
    this.props.descriptionChanged(e.currentTarget.value, this.props.index);
  }
  private handleValueChanged(e: any) {
    this.props.valueChanged(e.target.value, this.props.index);
  }
  private handleRateChanged(e: any) {
    this.props.rateChanged(e.target.value, this.props.index);
  }
  private handleUnitChanged(e: any) {
    this.props.unitChanged(e.target.value, this.props.index);
  }
  private deleteServiceCharge(e: any) {
    e.preventDefault();
    this.props.deleteServiceCharge(this.props.serviceCharge);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/ServiceChargeSmallRow.tsx